import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { uniqueId } from 'lodash';

function generateGradient({ fill, color, emptyColor }) {
  if (fill === 100) {
    return [
      <stop offset='0%' stopColor={ color } key='gradient1' />,
      <stop offset='100%' stopColor={ color } key='gradient2' />
    ];
  }
  return [
    <stop offset='0%' stopColor={ color } key='gradient3' />,
    <stop offset={ `${fill}%` } stopColor={ color } key='gradient4' />,
    <stop offset={ `${fill}%` } stopColor={ emptyColor } key='gradient5' />,
    <stop offset='100%' stopColor={ emptyColor } key='gradient6' />
  ];
}

function Star(props) {
  const { width } = props;
  const keyId = uniqueId();

  return (
    <div style={{ width: `${width}px` }}>
      <UX2.Element.SVG viewBox='0 0 50 50' style={{ width: '100%', height: 'auto' }}>
        <defs>
          <linearGradient id={ `fillStyle-${keyId}` }>{ generateGradient(props) }</linearGradient>
        </defs>
        <path
          d='m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z'
          fill={ `url(#fillStyle-${keyId})` }
        />
      </UX2.Element.SVG>
    </div>
  );
}

Star.propTypes = {
  width: PropTypes.string,
  fill: PropTypes.number,
  color: PropTypes.string,
  emptyColor: PropTypes.string
};

Star.defaultProps = {
  width: '20',
  fill: 100,
  color: 'rgb(28,182,71)',
  emptyColor: 'rgb(224,224,224)'
};

export default Star;
